<template>
  <button
    :class="`btn text-bg${getColor(type)}`"
    @click="handleClick"
    :disabled="!!disabled"
  >
    <span class="flex items-center justify-center gap-2">
      <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="sr-only" v-if="loading">처리중...</span>
      <span>{{ label }}</span>
    </span>
  </button>
</template>


<script>
export default {
  name: "Button",
  props: ["type", "label", "onClick", "loading", "disabled"],
  methods: {
    getColor(type) {
      return `-${type}`
    },
    handleClick() {
      if (this.onClick) {
        this.onClick(); // props로 전달된 함수 실행
      }
    }
  }
}
</script>

<style scoped>
.text-bg-red {
  color: #fff !important;
  background-color: rgba(239, 32, 32, 1);
}
.text-bg-red:hover {
  background-color: rgba(239, 32, 32, 0.8);
}
.text-bg-red:disabled {
  background-color: rgba(239, 32, 32, 0.4);
}

.text-bg-yellow {
  color: #fff !important;
  background-color: rgba(255, 196, 32, 1);
}
.text-bg-yellow:hover {
  background-color: rgba(255, 196, 32, 0.8);
}
.text-bg-yellow:disabled {
  background-color: rgba(255, 196, 32, 0.4);
}

.text-bg-green {
  color: #fff !important;
  background-color: rgba(25, 135, 84, 1);
}
.text-bg-green:hover {
  background-color: rgba(25, 135, 84, 0.8);
}
.text-bg-green:disabled {
  background-color: rgba(25, 135, 84, 0.4);
}

.text-bg-blue {
  color: #fff !important;
  background-color: rgba(32, 91, 239, 1);
}
.text-bg-blue:hover {
  background-color: rgba(32, 91, 239, 0.8);
}
.text-bg-blue:disabled {
  background-color: rgba(32, 91, 239, 0.4);
}

.text-bg-navy {
  color: #fff !important;
  background-color: rgba(32, 35, 239, 1);
}
.text-bg-navy:hover {
  background-color: rgba(32, 35, 239, 0.8);
}
.text-bg-navy:disabled {
  background-color: rgba(32, 35, 239, 0.4);
}

.text-bg-purple {
  color: #fff !important;
  background-color: rgba(108, 32, 239, 1);
}
.text-bg-purple:hover {
  background-color: rgba(108, 32, 239, 0.8);
}
.text-bg-purple:disabled {
  background-color: rgba(108, 32, 239, 0.4);
}

.text-bg-pink {
  color: #fff !important;
  background-color: rgba(199, 139, 217, 1);
}
.text-bg-pink:hover {
  background-color: rgba(199, 139, 217, 0.8);
}
.text-bg-pink:disabled {
  background-color: rgba(199, 139, 217, 0.4);
}

.text-bg-black {
  color: #fff !important;
  background-color: rgba(0, 0, 0, 1);
}
.text-bg-black:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.text-bg-black:disabled {
  background-color: rgba(0, 0, 0, 0.4);
}

.text-bg-outline {
  color: #000 !important;
  border: 1px solid #666;
  background-color: rgba(239, 239, 239, 1);
}
.text-bg-outline:hover {
  background-color: rgba(239, 239, 239, 0.8);
}
.text-bg-outline:disabled {
  background-color: rgba(239, 239, 239, 0.4);
}

.text-bg-default {
  color: #000 !important;
  background-color: rgba(206, 203, 203, 1);
}
.text-bg-default:hover {
  background-color: rgba(206, 203, 203, 0.8);
}
.text-bg-default:disabled {
  background-color: rgba(206, 203, 203, 0.4);
}

</style>